<template>
  <div>
    <div class="video-player-wrap">
      <!--视频组件-->
      <video-player
        class="video-player vjs-big-play-centered"
        ref="videoPlayer"
        :options="bindplayerOptions"
      >
      </video-player>
    </div>
    <div class="video-desc show-more">
      描述
      <!-- <img class="st_log" :src="'https://vjs.zencdn.net/v/oceans.mp4?vframe/jpg/offset/1/w/120/h/90'" alt /> -->
    </div>
    <div class="video-desc-switch">
      <el-link type="primary" :underline="false"
        >展示更多<i class="el-icon-arrow-down"></i
      ></el-link>
    </div>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
// import 'vue-video-player/src/custom-theme.css'
import { videoPlayer } from "vue-video-player";
export default {
  name: "VideoPlayer",
  components: { videoPlayer },
  props: {
    // mediaUrl: {
    //   type: String,
    //   default() {
    //     return ""
    //   }
    // }
    // 数据源
    sources: {
      type: Array,
      default: () => (
        []
      )
    },
  },
  data() {
    return {
      
      playerOptions: {
        playbackRates: [1.0, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: this.sources,
        //poster: "https://vjs.zencdn.net/v/oceans.png", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
    };
  },
  computed: {
    bindplayerOptions() {
      console.log(this.playerOptions);
      return this.playerOptions
    }
  },
  mounted() {
    //this.$refs.videoPlayer.play();
  },
  methods: {
    
  }
};
</script>

<style>
.video-js .vjs-big-play-button {
  /*
  播放按钮换成圆形
  */
  height: 2em;
  width: 2em;
  line-height: 2em;
  border-radius: 1em;
}
</style>
<style scoped>
.video-player-wrap {
  margin-bottom: 12px;
}

.video-desc {
  margin-bottom: 8px;
  color: #666;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.show-more {
  display: block;
  text-overflow: clip;
}
</style>